import { Link } from "react-router-dom";
import { LegalPage, LegalSection, LegalList, CompanyBox, COMPANY } from "./LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      eyebrow="Legale"
      title="Privacy Policy"
      intro="La presente informativa descrive come Hyper Consult SRL tratta i dati personali degli utenti di ViviTranquillo.com, ai sensi del Regolamento (UE) 2016/679 (GDPR)."
    >
      <CompanyBox />

      <LegalSection title="Titolare del trattamento">
        <p>
          Il Titolare del trattamento è {COMPANY.name}, {COMPANY.address} (P.IVA / C.F. {COMPANY.piva}). Per esercitare
          i propri diritti o per qualsiasi richiesta è possibile scrivere a {COMPANY.email} o via PEC {COMPANY.pec}.
        </p>
      </LegalSection>

      <LegalSection title="Dati trattati">
        <p>Nell'ambito dei servizi ViviTranquillo trattiamo le seguenti categorie di dati:</p>
        <LegalList
          items={[
            "Dati dell'account: nome, email e credenziali di accesso all'Area Clienti.",
            "Dati delle pratiche e richieste: informazioni fornite per utenze, credito, assicurazioni e servizi di controllo.",
            "Documenti caricati: documento di identità, tessera sanitaria e altra documentazione necessaria alla pratica.",
            "Dati di pagamento: gestiti tramite il provider Stripe; non conserviamo i dati della carta.",
            "Dati di assistenza e comunicazioni: messaggi scambiati con il nostro team.",
            "Dati relativi alle richieste di credito e ai controlli nelle banche dati creditizie.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Finalità e basi giuridiche">
        <LegalList
          items={[
            "Erogazione dei servizi richiesti e gestione del rapporto contrattuale (esecuzione del contratto).",
            "Gestione delle pratiche e inoltro delle richieste ai soggetti competenti su delega del Cliente (consenso ed esecuzione del contratto).",
            "Gestione dei pagamenti, della fatturazione e degli adempimenti di legge (obbligo legale).",
            "Assistenza clienti e comunicazioni di servizio (legittimo interesse / esecuzione del contratto).",
          ]}
        />
      </LegalSection>

      <LegalSection title="Comunicazione dei dati a terzi">
        <p>
          Per i servizi Controllo CRIF e Controllo Banche Dati, su delega del Cliente, i dati e i documenti necessari
          possono essere comunicati ai soggetti competenti (ad esempio CRIF, CTC, Experian, Banca d'Italia) al solo fine
          di presentare e gestire la richiesta. I dati di pagamento sono trattati dal provider Stripe. Non vendiamo i
          dati a terzi.
        </p>
      </LegalSection>

      <LegalSection title="Conservazione dei dati">
        <p>
          I dati sono conservati per il tempo necessario all'erogazione dei servizi e per gli adempimenti di legge
          (es. fiscali e contabili), dopodiché vengono cancellati o resi anonimi.
        </p>
      </LegalSection>

      <LegalSection title="Diritti dell'interessato">
        <p>In qualsiasi momento l'interessato può esercitare i seguenti diritti:</p>
        <LegalList
          items={[
            "Accesso ai propri dati personali.",
            "Rettifica dei dati inesatti.",
            "Cancellazione (diritto all'oblio) nei casi previsti.",
            "Limitazione del trattamento.",
            "Opposizione al trattamento.",
            "Portabilità dei dati.",
            "Reclamo all'Autorità Garante per la protezione dei dati personali.",
          ]}
        />
        <p>Le richieste possono essere inviate a {COMPANY.email}.</p>
      </LegalSection>

      <LegalSection title="Cookie">
        <p>
          L'utilizzo dei cookie è descritto nella{" "}
          <Link to="/cookie" className="font-semibold text-[#10B981] hover:underline">Cookie Policy</Link>.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
